define(["underscore", "360/item-class-config", "utils/match-criteria"], function(_, ItemClassConfig, MatchCriteria) {
  function EntityFormat(name, values) {
    this.name = name;
    this.values = values;
  }

  _.extend(EntityFormat.prototype, {
    getAlias: function() {
      return this.values.alias || this.name;
    }
  });

  function LinkConstraint(targetProperty, values) {
    this.targetProperty = targetProperty;
    this.values = values;
  }

  _.extend(LinkConstraint.prototype, {
    toQueryExpr: function() {
      var that = this;
      // TODO optionally use regex.
      return {
        or: _.map(this.values, function(value) {
          return { label: that.targetProperty, quoted_term: value };
        })
      };
    }
  });

  // like the Document Object Model for 360 Degree views.
  function Mindbreeze360Model(config) {
    // Config is the JSON serializable representations
    this.config = config;
  }

  _.extend(Mindbreeze360Model.prototype, {
    getConfig: function() {
      return this.config;
    },

    getLinkSourceProperties: function(sourceItemClass, destItemClassNames) {
      var that = this;
      var sourceClass =
        sourceItemClass instanceof ItemClassConfig ? sourceItemClass : this.findItemClassConfigForName(sourceItemClass);
      var destClasses = _.filter(
        _.map(destItemClassNames, function(itemClassName) {
          return that.findItemClassConfigForName(itemClassName);
        }),
        function(elt) {
          return elt != null;
        }
      );
      if (!sourceClass || _.isEmpty(destClasses)) {
        return [];
      }

      var sourcePropsByEF = sourceClass.getPropertiesByEntityFormat();

      var destsPropsByEF = _.map(destClasses, function(destClass) {
        return destClass.getPropertiesByEntityFormat();
      });

      var allDestEntityFormats = _.flatten(
        _.map(destsPropsByEF, function(obj) {
          return _.keys(obj);
        })
      );

      var sharedEFs = _.intersection(_.keys(sourcePropsByEF), allDestEntityFormats);
      return _.unique(
        _.reduce(
          sharedEFs,
          function(propertyNames, sharedEFName) {
            var props = sourcePropsByEF[sharedEFName];
            propertyNames = propertyNames.concat(
              _.map(props, function(prop) {
                return prop.name;
              })
            );
            return propertyNames;
          },
          []
        )
      );
    },

    getLinkConstraints: function(sourceItemClass, destItemClass, resultGetPropertyValuesFun) {
      var sourceClass =
        sourceItemClass instanceof ItemClassConfig ? sourceItemClass : this.findItemClassConfigForName(sourceItemClass);
      var destClass =
        destItemClass instanceof ItemClassConfig ? destItemClass : this.findItemClassConfigForName(destItemClass);
      if (!sourceClass || !destClass) {
        return [];
      }

      // e.g. BacklogItem: {ObjectAddress: [_FSCSCRUM_1_1001_storyversion/annotation/mes:key]}
      var sourcePropsByEF = sourceClass.getPropertiesByEntityFormat(destClass);
      // does it make sense to add the sourceClass to the destClass?
      var destPropsByEF = destClass.getPropertiesByEntityFormat(sourceClass);

      // intersect the two labels
      var sharedEFs = _.intersection(_.keys(sourcePropsByEF), _.keys(destPropsByEF));
      if (_.isEmpty(sharedEFs)) {
        return [];
      }

      var result = [];
      var that = this;
      _.each(sharedEFs, function(entityFormat) {
        var sourceProps = sourcePropsByEF[entityFormat];
        var destProps = destPropsByEF[entityFormat];
        var values = _.flatten(
          _.map(sourceProps, function(sourceProp) {
            return resultGetPropertyValuesFun(sourceProp.name);
          })
        );
        _.each(destProps, function(destProp) {
          if (!_.isEmpty(values)) {
            result.push(new LinkConstraint(destProp.name, values));
          }
        });
      });
      return result;
    },

    getViewConfigForClassName: function(itemClassName) {
      if (!this.config.views && !this.config.views[itemClassName]) {
        return null;
      }

      return this.config.views[itemClassName];
    },

    getPrimaryAliasNamesForItemClassName: function(itemClassName) {
      if (!this.config.itemClassAliases) {
        return [];
      }
      var that = this;
      var result = _.reduce(_.keys(this.config.itemClassAliases), function (aliases, aliasName) {
        var aliasEntry = that.config.itemClassAliases[aliasName];
        if (_.isObject(aliasEntry) && aliasEntry.isPrimary && aliasEntry.itemClassName == itemClassName) {
          aliases.push(aliasName);
        }
        return aliases;
      }, []);
      return result;
    },
    
    findItemClassConfigForName: function(itemClassName, options) {
      var options = options || {};
      if (!this.config.itemClasses) {
        return null;
      }
      var itemClass = this.config.itemClasses[itemClassName]
      if (!itemClass && options.useAliasMapping && this.config.itemClassAliases) {
        var itemClassAlias = itemClassName;
        var aliasEntry = this.config.itemClassAliases[itemClassAlias];
        if (_.isString(aliasEntry)) {
          itemClassName = aliasEntry;
        }
        else if (_.isObject(aliasEntry)) {
          itemClassName = aliasEntry.itemClassName;
        }
        if (itemClassName && itemClassName != itemClassAlias) {
          itemClass = this.config.itemClasses[itemClassName];
        }
      }      
      if (itemClass && itemClass.definition) {
        var criteria = new MatchCriteria(itemClass.definition);
        var superClass;
        // @todo for BacklogItem never comes here, definition is not set
        if (itemClass.subClassOf) {
          superClass = this.findItemClassConfigForName(itemClass.subClassOf);
        }
        
        return new ItemClassConfig(itemClassName, criteria, itemClass, superClass);
      }
      return null;
    },

    findItemClassConfigForResult: function(resultProperty) {
      // Trivial for now
      if (!this.config || !this.config.itemClasses) {
        return null;
      }

      // @todo
      /*
            var itemClassConfigByName = this.getAllItemClassConfigs();
          
            var res = _.find(
              _.keys(this.config.itemClasses), 
                function (itemClassName) { return itemClassConfigByName[itemClassName].matchesResult(resultProperties)
              });
            */

      var that = this;
      var foundItemClassName = _.find(_.keys(this.config.itemClasses), function(itemClassName) {
        if (!that.config.itemClasses[itemClassName].definition) {
          return false;
        }

        var itemClass = that.config.itemClasses[itemClassName];
        var criteria = new MatchCriteria(itemClass.definition);
        if (criteria.matches(resultProperty)) {
          return true;
        }

        return false;
      });

      if (!foundItemClassName) {
        return null;
      }
      var itemClass = this.config.itemClasses[foundItemClassName];
      var criteria = new MatchCriteria(itemClass.definition);

      if (criteria.matches(resultProperty)) {
        return new ItemClassConfig(foundItemClassName, criteria, itemClass);
      }
    },

    getAllItemClassDefinitionPropertyNames: function() {
      var itemClasses = this.getAllItemClassConfigs();
      var allPropertyNames = _.map(itemClasses, function(itemClass) {
        return itemClass.definitionMatchCriteria.getPropertyNames();
      });
      return _.uniq(allPropertyNames);
    },

    getAllItemClassConfigs: function() {
      var that = this;
      var itemClassNames = _.keys(this.config.itemClasses);
      return itemClassNames
        .map(function(itemClassName) {
          return that.findItemClassConfigForName(itemClassName);
        })
        .filter(function(itemClass) {
          return !!itemClass;
        });
    },

    getAllUniqueItemClassConfigsForEntityFormat: function(entityFormat) {
      var uniqueItemClasses = _.filter(this.getAllItemClassConfigs(), function(itemClass) {
        var propertyDefs = itemClass.getPropertiesByEntityFormat(entityFormat);
        var values = _.values(propertyDefs).reduce(function(accumulator, currVal) {
          return accumulator.concat(currVal);
        }, []);
        var includeUniqueDefinition = _.some(values, function(propertyDef) {
          return !!propertyDef.unique && propertyDef.entityFormat === entityFormat.name;
        });

        return includeUniqueDefinition;
      });

      return uniqueItemClasses;
    },

    getEntityFormatForLabel: function(entityFormatLabel) {
      function getObjectByKeyOrAlias(data, searchTerm) {
        searchTerm = searchTerm.toLowerCase();

        for (var key in data) {
          if (data.hasOwnProperty(key)) {
            if (key.toLowerCase() === searchTerm) {
              return new EntityFormat(key, data[key]);
            }

            if (data[key].alias && data[key].alias.toLowerCase() === searchTerm) {
              return new EntityFormat(key, data[key]);
            }
          }
        }

        return undefined;
      }

      if (this.config && this.config.entityFormats) {
        var entityFormat = getObjectByKeyOrAlias(this.config.entityFormats, entityFormatLabel);
        if (entityFormat) {
          return entityFormat;
        }
      }

      return null;
    }
  });

  return {
    Mindbreeze360Model: Mindbreeze360Model,
    LinkConstraint: LinkConstraint,
    EntityFormat: EntityFormat
  };
});
